import React from "react";
import { Button, Switch, Icon } from "../";

const DeliveryGroupCard = ({
  group,
  onViewDetails,
  onToggleStatus,
  isToggling,
}) => {
  const getTypeLabel = (type) => {
    if (type === 0) return "In-house drivers";
    if (type === 1) return "Delivery companies";
    return "Unknown";
  };

  const borderColor = group?.enabled
    ? "border-success/50 hover:border-success/70"
    : "border-destructive/50 hover:border-destructive/70";

  return (
    <div
      className={`ordering-delivery-card bg-background relative rounded-lg border-2 ${borderColor} p-4 transition-colors`}
    >
      <Button
        type="button"
        aria-label={group?.name || "Unknown"}
        onClick={() => onViewDetails?.(group)}
        disabled={!onViewDetails}
        variant="ghost"
        className="absolute inset-0 h-auto w-full rounded-[inherit] bg-transparent p-0 shadow-none hover:bg-transparent disabled:cursor-default disabled:opacity-100"
      />
      <div className="flex items-center justify-between">
        <div className="pointer-events-none relative z-[1] min-w-0 flex-1">
          <div className="mb-2">
            <h3 className="truncate font-medium text-white">
              {group?.name || "Unknown"}
            </h3>
          </div>
          <div className="flex items-center space-x-2">
            <Icon
              name="Tag"
              className="text-muted-foreground h-4 w-4 flex-shrink-0"
            />
            <span className="text-muted-foreground text-sm">
              {getTypeLabel(group?.type)}
            </span>
          </div>
        </div>
        <div className="relative z-[1] ml-4 flex flex-shrink-0 items-center space-x-2">
          <Switch
            checked={!!group?.enabled}
            onCheckedChange={() =>
              onToggleStatus && onToggleStatus(group.id, !group?.enabled)
            }
            disabled={isToggling}
          />
        </div>
      </div>
    </div>
  );
};

export default DeliveryGroupCard;
